/**
 * en-GB messages added by Phase 1 task C1 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const c1EnGB = {
    'error.file_mime': 'That type of file is not allowed here.',
    'error.pairing_code_invalid': 'That pairing code is not valid. Check the number and try again.',
};
//# sourceMappingURL=c1.js.map